import { MerchantAllowedComponents } from '../../models/authentication/merchant-allowed-components.model';
import { MerchantDto } from '../../dto/merchant.dto';
import { MerchantGroupDto } from '../../dto/merchantGroup.dto';
import { RoleData } from './RoleData';

interface AuthUserProfile {
  displayName: string;
  profileImageURL?: string;
  [key: string]: any;
}

export type AllowedComponents =
  | {
    /** Only defined for admin type of a user. */
    consumer: 'system-admin';
    componentList: string[];
  }
  | {
    /** Only defined for manager type of a user. */
    consumer: 'manager';
    componentList: MerchantAllowedComponents;
  };

/**
 * Employee profile for an linked user.
 */
export type UserEmployeeProfile = {
  employeeId: number;
  displayName: string;
};

export class AuthInfo {
  public uuid: string;
  public id: number;
  public email: string;
  public token: string;
  public tokenExpiration?: Date = null;
  public refreshToken: string;
  public refreshTokenExpiration: Date;
  public roleData: RoleData;
  public mainRoleName?: string;
  public subRoleNames?: string[];
  public merchantsLookup?: MerchantDto[];
  public merchantGroup?: MerchantGroupDto;
  public profile: AuthUserProfile;
  public createdDate?: Date;
  public purchasingCanSeePrices?: boolean;
  public allowDirectGoodsReceived?: boolean;
  /**  Fallback legacy compatible version of allowed components. */
  public allowedComponents: string[];
  /** New version of the allowed components */
  public allowedComponentsV2: AllowedComponents;
  public needsOnboarding?: boolean;
  public timeoutAfterMinutes?: number;
  /** The employee profile of the user. */
  public employeeProfile: UserEmployeeProfile | null;
}
